import { render, staticRenderFns } from "./BusinessLocation.vue?vue&type=template&id=651c6e14&"
import script from "./BusinessLocation.vue?vue&type=script&lang=js&"
export * from "./BusinessLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports